module.exports = __webpack_public_path__ + "static/media/eecs_parts_052123.c1b9ded9.png";